import { styled } from "@mui/material";
import React from "react";
import { v4 as uuid } from "uuid";
import { Dialog, DialogContent, DialogFooter, DialogTitle } from "../DialogComponents";
const classes = {
    title: "message-dialog-title"
};
const StyledDiv = styled("div")(({ theme }) => ({
    [`& .${classes.title}`]: {
        fontSize: theme.typography.pxToRem(16)
    }
}));
export const MessageDialog = ({ open, onClose, size, title, footer, "aria-describedby": ariaDescribedBy, message }) => {
    const titleId = title ? `${uuid()}-title` : undefined;
    return (React.createElement(Dialog, { open: open, onClose: onClose, size: size, "aria-describedby": ariaDescribedBy, "aria-labelledby": titleId },
        title && (React.createElement(StyledDiv, { className: classes.title },
            React.createElement(DialogTitle, { className: classes.title, id: titleId }, title))),
        React.createElement(DialogContent, { style: { padding: "8px 30px" } },
            React.createElement("p", null, message)),
        footer && React.createElement(DialogFooter, null, footer)));
};
//Prop defaults
MessageDialog.defaultProps = {
    open: false,
    disabled: false,
    size: "xs"
};
